import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

function TitlePill({ badgeTitle, badgeStyle }) {
    return (
        <span className={`title-badge badge-${badgeStyle}`}>{badgeTitle}</span>
    );
}

TitlePill.propTypes = {
    // text to be displayed inside pill
    badgeTitle: PropTypes.string,
    // boolean to determine badge class in order change colour
    badgeStyle: PropTypes.string,
};

TitlePill.defaultProps = {
    badgeTitle: null,
    badgeStyle: 'simple',
};

export default TitlePill;
